import React from 'react';
import { Link } from 'react-router-dom';
import { Gift, Sparkles, Cake, ArrowRight, Check } from 'lucide-react';

const FidelitePage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-20">
      {/* HERO */}
      <section className="relative py-20 px-6 bg-gradient-to-br from-[#5C2018] to-[#2E120D] overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "url('/assets/rose-filigrane.jpg')", backgroundSize: 'cover' }} />
        <div className="relative max-w-3xl mx-auto text-center">
          <Sparkles size={28} className="text-[#B8922A] mx-auto mb-3" />
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-3">Programme de fidélité</p>
          <h1
            className="text-5xl md:text-6xl text-[#FDFAF4] mb-5"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="fidelite-title"
          >
            Le Cercle Harmony
          </h1>
          <p className="text-lg text-[#FDFAF4]/90 font-light leading-relaxed max-w-xl mx-auto">
            Parce que votre fidélité nous touche, nous l&apos;honorons à notre manière —
            avec deux gestes simples et généreux.
          </p>
        </div>
      </section>

      {/* LES 2 PILIERS */}
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Points */}
          <div className="bg-white rounded-2xl border-2 border-[#B8922A]/40 p-8 shadow-[0_20px_50px_rgba(92, 32, 24,0.08)]" data-testid="fidelite-pilier-points">
            <div className="w-14 h-14 rounded-full bg-[#B8922A]/15 flex items-center justify-center mb-5">
              <Sparkles size={26} className="text-[#B8922A]" />
            </div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#B8922A] mb-2">Pilier 1</p>
            <h2 className="text-3xl text-[#5C2018] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              Vos points Harmony
            </h2>
            <p className="text-sm text-[#332724] font-light leading-relaxed mb-3">
              Chaque euro dépensé chez Harmony vous fait gagner <strong>1 point fidélité</strong>.
              Cumulez tranquillement, sans pression, sans date d&apos;expiration.
            </p>
            <div className="bg-[#5C2018]/8 border-l-4 border-[#5C2018] rounded-r-lg p-3 mb-5">
              <p className="text-xs text-[#5C2018] font-medium leading-relaxed">
                <strong>⚠️ Important :</strong> 1 point n&apos;est <strong>pas</strong> égal à 1€.
                Plus vous cumulez de points, plus la réduction associée est <strong>généreuse</strong>
                (de 10% à 15% en cashback selon le palier atteint).
              </p>
            </div>
            <div className="bg-[#FDFAF4] rounded-xl p-5 mb-5">
              <p className="text-xs uppercase tracking-[0.2em] text-[#1E7A6A] mb-3">Le barème de conversion</p>
              <ul className="text-sm space-y-3 text-[#332724]">
                <li className="flex items-center justify-between pb-2 border-b border-[#B8922A]/15">
                  <span className="font-light">Pour chaque <strong>1€</strong> dépensé</span>
                  <span className="font-medium text-[#5C2018]">+1 point cumulé</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="font-light">
                    100 pts <em className="text-[10px] text-[#332724]/60">(= 100€ d&apos;achats)</em>
                  </span>
                  <span className="font-medium text-[#B8922A]">10€ de réduction <span className="text-[10px] text-[#1E7A6A]">(10%)</span></span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="font-light">
                    250 pts <em className="text-[10px] text-[#332724]/60">(= 250€ d&apos;achats)</em>
                  </span>
                  <span className="font-medium text-[#B8922A]">30€ de réduction <span className="text-[10px] text-[#1E7A6A]">(12%)</span></span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="font-light">
                    500 pts <em className="text-[10px] text-[#332724]/60">(= 500€ d&apos;achats)</em>
                  </span>
                  <span className="font-medium text-[#B8922A]">75€ de réduction <span className="text-[10px] text-[#1E7A6A]">(15%)</span></span>
                </li>
              </ul>
            </div>
            <p className="text-xs text-[#332724]/70 italic">
              💡 Vos points s&apos;utilisent <strong>par paliers</strong> sur tout achat en boutique ou en ligne (sauf échantillons et frais de port).
            </p>
          </div>

          {/* Anniversaire */}
          <div className="bg-gradient-to-br from-[#B8922A]/10 to-white rounded-2xl border-2 border-[#B8922A] p-8 shadow-[0_20px_50px_rgba(184,146,42,0.15)]" data-testid="fidelite-pilier-anniv">
            <div className="w-14 h-14 rounded-full bg-[#5C2018] text-[#FDFAF4] flex items-center justify-center mb-5">
              <Cake size={26} />
            </div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#B8922A] mb-2">Pilier 2</p>
            <h2 className="text-3xl text-[#5C2018] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              Le cadeau anniversaire
            </h2>
            <p className="text-sm text-[#332724] font-light leading-relaxed mb-5">
              Pendant tout votre <strong>mois d&apos;anniversaire</strong>, profitez de
              <strong> -20% sur tout achat</strong> en boutique et en ligne.
            </p>
            <div className="bg-white rounded-xl p-5 mb-5 border border-[#B8922A]/20">
              <p className="text-xs uppercase tracking-[0.2em] text-[#1E7A6A] mb-3">Comment ça marche</p>
              <ul className="text-sm space-y-2 text-[#332724]">
                <li className="flex items-start gap-2 font-light">
                  <Check size={14} className="text-[#B8922A] mt-1 flex-shrink-0" />
                  <span>Indiquez-nous votre date d&apos;anniversaire lors de votre inscription</span>
                </li>
                <li className="flex items-start gap-2 font-light">
                  <Check size={14} className="text-[#B8922A] mt-1 flex-shrink-0" />
                  <span>Vous recevez votre code -20% le 1ᵉʳ du mois</span>
                </li>
                <li className="flex items-start gap-2 font-light">
                  <Check size={14} className="text-[#B8922A] mt-1 flex-shrink-0" />
                  <span>Valable sur tous nos produits (sauf bons cadeaux)</span>
                </li>
                <li className="flex items-start gap-2 font-light">
                  <Check size={14} className="text-[#B8922A] mt-1 flex-shrink-0" />
                  <span>Cumulable avec vos points Harmony</span>
                </li>
              </ul>
            </div>
            <p className="text-xs text-[#332724]/70 italic">
              🎂 Un parfum coûte cher. Votre anniversaire mérite qu&apos;on l&apos;allège.
            </p>
          </div>
        </div>
      </section>

      {/* COMMENT REJOINDRE */}
      <section className="py-16 px-6 bg-[#FDFAF4]">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-3">Rejoindre le Cercle</p>
          <h2 className="text-4xl text-[#5C2018] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
            En 30 secondes, à votre premier passage en boutique
          </h2>
          <div className="bg-white rounded-2xl p-8 border border-[#B8922A]/30 shadow-[0_15px_40px_rgba(92, 32, 24,0.05)]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { n: '1', t: 'Donnez votre nom + email', d: 'Lors de votre prochain achat en boutique ou par téléphone' },
                { n: '2', t: 'Indiquez votre anniversaire', d: 'Pour activer votre -20% annuel automatique' },
                { n: '3', t: 'On crédite vos points', d: 'À chaque achat, nous ajoutons vos points sur votre compte' },
              ].map((s) => (
                <div key={s.n} className="text-center">
                  <div className="w-12 h-12 rounded-full bg-[#5C2018] text-[#FDFAF4] flex items-center justify-center mx-auto mb-3 text-lg" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
                    {s.n}
                  </div>
                  <p className="text-sm font-medium text-[#5C2018] mb-1.5">{s.t}</p>
                  <p className="text-xs text-[#332724]/75 font-light leading-relaxed">{s.d}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 pt-6 border-t border-[#B8922A]/15 space-y-3">
              <Link
                to="/mon-solde"
                className="inline-flex items-center gap-2 btn-primary px-7 py-3 rounded-full text-xs uppercase tracking-[0.2em]"
                data-testid="fidelite-cta-solde"
              >
                <Gift size={14} /> Je consulte mon solde de points
                <ArrowRight size={14} />
              </Link>
              <p className="text-[11px] text-[#332724]/60 italic">
                Pas encore membre ? <strong>Demandez votre inscription</strong> lors de votre prochain passage en boutique
                (14 Av. Sergent Bobillot, 34500 Béziers) ou par téléphone au <a href="tel:0467215708" className="underline text-[#1E7A6A]">04 67 21 57 08</a>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PETITES PRÉCISIONS */}
      <section className="py-12 px-6 bg-white">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-4 text-center">Les règles du jeu</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs text-[#332724]/80 font-light">
            <p>✦ Programme gratuit, sans engagement, valable en France métropolitaine.</p>
            <p>✦ Vos points n&apos;expirent jamais — prenez votre temps.</p>
            <p>✦ Les points sont créditées sous 48h après chaque achat confirmé.</p>
            <p>✦ Le code anniversaire vous est envoyé par email le 1ᵉʳ du mois.</p>
            <p>✦ Programme non cumulable avec d&apos;autres réductions promotionnelles ponctuelles.</p>
            <p>✦ Vous pouvez consulter votre solde de points en boutique ou par téléphone à tout moment.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FidelitePage;
